/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	baseShippingInfoProcessed,
	dynamicTemplateChosen,
	eddInfoFetched,
	eddInfoFetchErrored,
	fetchSDDInfoError,
	fetchSDDInfoSuccess,
	bundleProductDataInitialized,
	productStyleAndSkusInitialized,
	inventoryFetched,
	inventoryFetchErrored,
	outOfStockTemplateInitialized,
	promotionsFetched,
	resolvedSkuShippingInfoProcessed,
	customProductUpdated,
	setFBTProducts,
	primaryCategoryFetched,
	productHasBothEmptyAndNonEmptyPriceChecked,
	personalizationOptionsUpdated,
	styliticsShopTheLookWidgetMounted,
	skuResolutionActions
} from './product-selection.actions';

import { ProductSelectionCoreState } from '@pdp/data-access/interfaces';
import { DynamicProductTemplateModules } from '@pdp/data-access/enums';

// 02 Define the initial state
export const initialProductSelectionState: ProductSelectionCoreState = {
	productStyle: {},
	bundleData: {},
	bundleProductsData: [],
	productSkus: [],
	resolvedSku: null,
	resolvedSkuSDDInventory: null,
	sddError: null, // Store error state for SDD
	ecommInventory: null,
	bopisInventory: null,
	primaryCategory: null,
	hasBothEmptyAndNonEmptyPrice: false,
	shippingInfo: {},
	promotionData: null,
	eddInfo: null,
	eddError: null, // Store error state for EDD
	customProductData: null,
	loadingProductImages: false,
	selectedPersonalizationOptions: {},
	FBTProducts: [],
	styliticsWidgetShown: false,
	productHasColorWithStylitics: false,
	templateName: DynamicProductTemplateModules.NOT_FOUND_DEFAULT
};

export const productSelectionReducers = createReducer(
	// Supply the initial state
	initialProductSelectionState,
	on(dynamicTemplateChosen, (state, { templateName }) => ({
		...state,
		templateName
	})),
	on(productStyleAndSkusInitialized, (state, { productStyle, productSkus }) => ({
		...state,
		productStyle,
		productSkus
	})),
	on(bundleProductDataInitialized, (state, { bundleData, bundleProductsData }) => ({
		...state,
		bundleData,
		bundleProductsData
	})),
	on(...skuResolutionActions, (state, { resolvedSku }) => ({
		...state,
		resolvedSku,
		eddInfo: undefined
	})),
	on(fetchSDDInfoSuccess, (state, { sdd }) => ({
		...state,
		resolvedSkuSDDInventory: sdd,
		sddError: null
	})),
	on(fetchSDDInfoError, (state, { error }) => ({
		...state,
		resolvedSkuSDDInventory: null,
		sddError: error
	})),
	on(eddInfoFetched, (state, { eddInfo }) => ({
		...state,
		eddInfo,
		eddError: null
	})),
	on(eddInfoFetchErrored, (state, { error }) => ({
		...state,
		eddInfo: null,
		eddError: error
	})),
	on(inventoryFetched, (state, { ecommInventory, bopisInventory }) => ({
		...state,
		ecommInventory,
		bopisInventory
	})),
	on(inventoryFetchErrored, (state) => ({
		...state,
		ecommInventory: [],
		bopisInventory: []
	})),
	on(primaryCategoryFetched, (state, { primaryCategory }) => ({
		...state,
		primaryCategory
	})),
	on(productHasBothEmptyAndNonEmptyPriceChecked, (state, { hasBothEmptyAndNonEmptyPrice }) => ({
		...state,
		hasBothEmptyAndNonEmptyPrice
	})),
	on(baseShippingInfoProcessed, resolvedSkuShippingInfoProcessed, (state, { shippingInfo }) => ({
		...state,
		shippingInfo
	})),
	on(promotionsFetched, (state, { promotionData }) => ({
		...state,
		promotionData
	})),
	on(customProductUpdated, (state, { customProductData }) => ({
		...state,
		customProductData
	})),
	on(personalizationOptionsUpdated, (state, { selectedPersonalizationOptions }) => ({
		...state,
		selectedPersonalizationOptions
	})),
	on(setFBTProducts, (state, { FBTProducts }) => ({
		...state,
		FBTProducts
	})),
	on(styliticsShopTheLookWidgetMounted, (state, { styliticsWidgetShown }) => ({
		...state,
		styliticsWidgetShown,
		productHasColorWithStylitics: state.productHasColorWithStylitics || styliticsWidgetShown
	})),
	on(outOfStockTemplateInitialized, (state) => ({
		...state,
		ecommInventory: [],
		bopisInventory: [],
		promotionData: {}
	}))
);
